var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "notification__item" },
    [
      _c("div", { domProps: { innerHTML: _vm._s(_vm.createdDate) } }),
      _vm._v(" "),
      _c(
        "v-list-tile",
        {
          key: _vm.id,
          staticClass: "notification__item--round",
          class: _vm.colorClass,
          attrs: {
            color: _vm.textColorClass,
            "active-class": "notification__item"
          },
          on: { click: _vm.handleOnClick }
        },
        [
          _vm.avatar
            ? _c("v-list-tile-avatar", [
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "50px !important",
                      height: "50px !important"
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "notification__avatar",
                      attrs: { src: _vm.avatar.link, title: _vm.avatar.name }
                    })
                  ]
                )
              ])
            : _c("div", { staticClass: "notification__item--avatar" }, [
                _c("span", [_vm._v(" " + _vm._s(_vm.avatarText))])
              ]),
          _vm._v(" "),
          _c(
            "v-list-tile-content",
            { staticStyle: { "margin-left": "10px" } },
            [
              _vm.name
                ? _c("strong", {
                    staticClass: "header__notification--title mb-2",
                    class: _vm.textColorClass,
                    domProps: { innerHTML: _vm._s(_vm.name) }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", {
                staticClass: "header__notification--title",
                class: _vm.textColorClass,
                domProps: { innerHTML: _vm._s(_vm.message) }
              }),
              _vm._v(" "),
              _c("v-list-tile-sub-title", {
                staticClass: "header__notification--sub-title",
                class: _vm.textColorClass,
                domProps: { innerHTML: _vm._s(_vm.subInfo) }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9b27cc4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b27cc4a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/header-notifications-item/template.html
// module id = null
// module chunks = 